import t from "babel-plugin-yate/macro";

export default (status) => {
  switch (status) {
    default:
    case "new":
      return {
        type: "new",
        text: t`New`,
        badgeColor: "grey-1",
        disabled: "",
      };
    case "awaiting_cb_consent":
      return {
        type: "awaiting_cb_consent",
        text: t`Awaiting CB consent`,
        badgeColor: "orange",
        disabled: "",
      };
    case "awaiting_cb":
      return {
        type: "awaiting_cb",
        text: t`Awaiting CB`,
        badgeColor: "grey-1",
        disabled: "",
      };
    case "cb_ok":
      return {
        type: "cb_ok",
        text: t`CB OK`,
        badgeColor: "green-light",
        disabled: "bc_credit",
      };
    case "awaiting_kyc":
      return {
        type: "awaiting_kyc",
        text: t`Awaiting KYC`,
        badgeColor: "orange",
        disabled: "all",
      };
    case "ocr":
      return {
        type: "ocr",
        text: t`OCR`,
        badgeColor: "orange",
        disabled: "",
      };
    case "selfie":
      return {
        type: "selfie",
        text: t`Selfie`,
        badgeColor: "orange",
        disabled: "all",
      };
    case "kyc_ok_awaiting_address":
      return {
        type: "kyc_ok_awaiting_address",
        text: t`Asteptare adresa CI`,
        badgeColor: "blue-light",
        disabled: "",
      };
    case "kyc_ok":
      return {
        type: "kyc_ok",
        text: t`KYC OK`,
        badgeColor: "green-light",
        disabled: "",
      };
    case "awaiting_anaf_consent":
      return {
        type: "awaiting_anaf_consent",
        text: t`Awaiting ANAF consent`,
        badgeColor: "orange",
        disabled: "anaf_credit",
      };

    case "awaiting_anaf":
      return {
        type: "awaiting_anaf",
        text: t`Awaiting ANAF`,
        badgeColor: "grey-1",
        disabled: "anaf_credit",
      };
    case "anaf_ok":
      return {
        type: "anaf_ok",
        text: t`ANAF OK`,
        badgeColor: "green-light",
        disabled: "",
      };
    case "analysis":
      return {
        type: "analysis",
        text: t`Analysis`,
        badgeColor: "purple",
        disabled: "all",
      };
    case "manual_analysis":
      return {
        type: "manual_analysis",
        text: t`Manual analysis`,
        badgeColor: "purple",
        disabled: "all",
      };
    case "risk_analysis":
      return {
        type: "risk_analysis",
        text: t`Risk analysis`,
        badgeColor: "purple",
        disabled: "",
      };
    case "risk_manual_analysis":
      return {
        type: "risk_manual_analysis",
        text: t`Risk Manual analysis`,
        badgeColor: "purple",
        disabled: "",
      };
    case "risk_validated":
      return {
        type: "risk_validated",
        text: t`Risk validated`,
        badgeColor: "green-light",
        disabled: "",
      };
    case "approved":
      return {
        type: "approved",
        text: t`Approved`,
        badgeColor: "green-light",
        disabled: "all",
      };
    case "awaiting_esign":
      return {
        type: "awaiting_esign",
        text: t`Awaiting eSign`,
        badgeColor: "purple-light",
        disabled: "all",
      };
    case "signed":
      return {
        type: "signed",
        text: t`Signed`,
        badgeColor: "green",
        disabled: "all",
      };
    case "done":
      return {
        type: "done",
        text: t`Done`,
        badgeColor: "green",
        disabled: "all",
      };
    case "rejected":
      return {
        type: "rejected",
        text: t`Rejected`,
        badgeColor: "red",
        disabled: "all",
      };
    case "canceled":
      return {
        type: "canceled",
        text: t`Cancelled`,
        badgeColor: "red",
        disabled: "all",
      };
    case "duplicate_contract":
    case "unknown":
      return {
        type: "unknown",
        text: t`Unknown`,
        badgeColor: "grey-darkest",
        disabled: "all",
      };
  }
};
